// extracted by mini-css-extract-plugin
module.exports = {"counter":"styles_counter__Ji15E","plus":"styles_plus__e_qG2","key":"styles_key__3_MQ3"};